
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Util from '@/lib/util';
import Order from '@/store/entities/ordering/Order';
import OrderItem from '@/store/entities/ordering/OrderItem';

@Component
export default class OrderItemEditingList extends AbpBase {
    @Prop() form: any;
    @Prop({default:() => {}}) order: Order;

    handleAdd () {
        this.order.orderItems.push({
            id: 0,
            orderId: this.order.id,
            productId: 0,
            productNo: '',
            productName: '',
            unitPrice: 0,
            productImageUrl: '',
            quantity: 0,
            tenantId: 0,
            buyerRemark: '',
            vendorNo: '',
            remark: '',
            creationTime: new Date(),
            authMode: ''
        });
    }
    handleRemove (index) {
        this.order.orderItems.splice(index, 1);
    }
}
